declare let window: {
  env?: Record<string, string>;
};

const env = window.env ? window.env : {};

export default env;
